import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";

import { HeadService } from "@hermes/utils-generic/services/head";

@Injectable()
export class ResetPasswordTitleResolver implements Resolve<void> {
    constructor(private headService: HeadService) {}

    public resolve(): void {
        this.headService.setTitle(
            $localize`:@@hermes-global-translations.reset-password:Reset password`,
            true,
        );
    }
}
